'use client';

export const EN = {
  test: {
    'This is a test 1': 'This is a test string 1',
    'This is a test 2': 'This is a test string 2',

    Item_one: 'Item',
    Item_other: 'Items',

    Apple_one: '{{count}} apple',
    Apple_other: '{{count}} apples',
  },

  misc: {
    or: 'or',
    close: 'Close',
    cancel: 'Cancel',
  },

  connect: {
    heading: 'Sign in to Elys',
    verify: 'Always verify that you are on',

    connectWithEmail: 'Connect with Email',
    connectWithSocialAccount: 'Connect with Social Account',
    connectWithDigitalWallet: 'Connect with Wallet',
    connectWith: 'Connect with',

    connectWithWalletTooltip:
      'Connect with a digital wallet to access the Elys Network. Remember to reload the page if you just installed the extension.',
  },

  error: {
    notFoundDesc: "We can't find the page you're looking for.",

    goBackHome: 'Go back home',
  },
};
